import styled from "styled-components";

export const JOBHAPPIER_ID = "716047581885055";
export const INSTAGRAM_IMAGE_SIZE_SPEC = {
  // 16:9 = 640:360
  width: 360,
  height: 640,
  pictureWidth: 360,
  minHeight: 640,
  maxHeight: 640
};
export const PostEditorInstagramWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${INSTAGRAM_IMAGE_SIZE_SPEC.width}px;
`;

export const InstagramLongWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${INSTAGRAM_IMAGE_SIZE_SPEC.width}px;
  box-shadow: 0px 2px 4px 0px #1516331f;
  background: #9ca2ac;
  border-radius: 4px;
  position: relative;
`;

export const Bar = styled.div`
  width: 94%;
  height: 3px;
  background: lightgray;
  border-radius: 3px;
  position: relative;
  z-index: 10;
`;

export const Progress = styled.div`
  width: 30%;
  height: 3px;
  background: white;
  border-radius: 3px;
  position: absolute;
`;
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 7px 7px 6px;
  margin-bottom: 40px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 4;
  width: 100%;
`;
export const EditorWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  margin-bottom: 128px;
  left: 50%;
  transform: translateX(-50%);
  width: ${INSTAGRAM_IMAGE_SIZE_SPEC.width}px;
  padding: 0 4px;
  z-index: 4;
`;
export const FooterWrapper = styled.div`
  margin: 50px 0px 10px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 55px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  z-index: 4;
  svg {
    transform: scale(0.5);
  }
`;
export const InstagramLearnMoreAnchor = styled.a`
  line-height: 16px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  appearance: none;
  user-select: none;
  cursor: pointer;
  &:hover {
    color: white;
  }
`;
export const InstagramLearnMoreArrow = styled.img`
  display: block;
  margin: 0 auto;
  width: 30px;
  border-radius: 100%;
`;
export const teaserTextStyle = {
  fontWeight: 600,
  fontSize: "15px",
  lineHeight: "1.3em"
};
